/**
 *
 * @param {Object} { state, payload },
 */
const setCurrentCartRecaps = (state, payload) => {
  if (typeof payload.items != 'undefined' && Array.isArray(payload.items)) {
    let differentTaxRates = [];
      payload.items.forEach(element => {
          if(!differentTaxRates.includes(element.tax_percent) && element.price > 0){
            differentTaxRates.push(element.tax_percent);
          }

          if (typeof element.type != 'undefined' && element.type === "intervention") {
              state.commit("ADD_INTERVENTION_OPTION_TO_CURRENT_CART", {'option': element, 'nbTaxRates': differentTaxRates.length});
          } else {
              state.commit("ADD_PRODUCT_TO_CURRENT_CART", {'product': element, 'nbTaxRates': differentTaxRates.length});
          }
      });
  }

  if (typeof payload.options != 'undefined' && payload.options != null && typeof payload.options.essential_services != 'undefined') {
      if(payload.options && payload.options.essential_services) {
            payload.options.essential_services.forEach(element => {
              state.commit("ADD_ESSENTIAL_OPTION_TO_CURRENT_CART", element);
          })
      }
  }

  if (typeof payload.options != 'undefined' && payload.options != null && typeof payload.options.essential_options != 'undefined') {
      if(payload.options && payload.options.essential_options) {
          payload.options.essential_options.forEach(element => {
              state.commit("ADD_ADDITIONAL_OPTION_TO_CURRENT_CART", element);
          })
      }
  }

  state.commit("SET_CURRENT_CART_RENTING_AMOUNTS", payload);
  state.commit("SET_CURRENT_CART_COUPON_CODE", payload);
  state.commit("SET_CURRENT_CART_ERROR_MESSAGES", payload);
  state.commit("SET_CURRENT_CART_TOTAL", payload);
  state.commit("SET_CURRENT_CART_DELIVERY", payload);
  state.commit("SET_CURRENT_CART_DELIVERY_TYPE", payload);
  state.commit("SET_CURRENT_CART_SCHEDULE", payload);
  state.commit("SET_CURRENT_CART_DISCOUNT", payload);
  state.commit("SET_CURRENT_CART_DISCOUNT_DETAILS", payload);
  state.commit("SET_CURRENT_CART_CGV", payload);
  state.commit("SET_CUSTOMER_SERVICE_INFO", payload);
  state.commit("SET_CURRENT_CART_CHECKOUT_URL", payload);
  state.commit("SET_CURRENT_CART_REFFERER_DISCOUNT", payload);
  state.commit("SET_CURRENT_CART_TOTAL_WITHOUT_DISCOUNT_REFERRER", payload);
  state.commit("SET_CURRENT_CART_TOTAL_ITEMS_COUNT", payload);
  state.commit("SET_CURRENT_CART_TOTAL_ITEMS_QTY", payload)
  state.commit("SET_CURRENT_CART_CONFIG", payload);
  state.commit("SET_CURRENT_CART_GTM_DATAS", payload);
  state.commit("SET_MAIN_ITEM", payload);
  state.commit("SET_STANDART_DELIVERY_IN_CART", payload);
  state.commit("SET_INSTALLATION_PRODUCT_IN_CART", payload);
  state.commit("SET_CUSTOMER_TAX_ID", payload);
  state.commit("SET_TAX_HIGH_RATE", payload);
  state.commit("SET_TAX_PROFILS", payload);

  // TODO: remove it when header will be done in vue js
  let miniCart = 'header_cart' in payload ? document.querySelector(payload.header_cart.mini_cart.id) : null;
  let topLink = 'header_cart' in payload ? document.querySelector(payload.header_cart.top_link.id) : null;

  if ('header_cart' in payload && payload.header_cart.top_link && topLink) {
    topLink.innerHTML = payload.header_cart.top_link.html;
  }

  if ('header_cart' in payload && payload.header_cart.mini_cart && miniCart) {
    miniCart.innerHTML = payload.header_cart.mini_cart.html;
  }
};


const setCurrentCartDeliveryAbsoluteType = (state, payload) => {
  state.commit("SET_CURRENT_CART_DELIVERY_ABSOLUTE_TYPE", payload);
}

/**
 *
 * @param {Object} { state, payload },
 */
const removeCurrentCartRecaps = state => {
  state.commit("CLEAN_PRODUCTS_TO_CURRENT_CART");
  state.commit("CLEAN_ESSENTIAL_OPTIONS_TO_CURRENT_CART");
  state.commit("CLEAN_ADDITIONAL_OPTIONS_TO_CURRENT_CART");
  state.commit("CLEAN_INTERVENTIONS_OPTIONS_TO_CURRENT_CART");
};

/**
 *
 * @param {Object} { state, payload },
 */
const updateCurrentCartRecaps = (state, payload) => {
  state.dispatch("removeCurrentCartRecaps");
  state.dispatch("setCurrentCartRecaps", payload);
};

const setCurrentCartEcoTaxe = (state, ecoTaxe) => {
  state.commit("SET_CURRENT_CART_ECO_TAX", ecoTaxe);
};


/**
 * 
 * @param {Object} state 
 * @param {String} universe 
 */
const setCurrentCartUniverse = (state, universe) => {
  state.commit("SET_MCP_UNIVERSE", universe)
}

const setDeliveryDateNull = (state) => {
  state.commit("SET_CART_DELIVERY_DATE_NULL")
}

export default {
  setCurrentCartRecaps,
  removeCurrentCartRecaps,
  updateCurrentCartRecaps,
  setCurrentCartEcoTaxe,
  setCurrentCartDeliveryAbsoluteType,
  setCurrentCartUniverse,
  setDeliveryDateNull
};
